import { render, staticRenderFns } from "./TopTitleSubtitlePage.vue?vue&type=template&id=5230100e&"
import script from "./TopTitleSubtitlePage.vue?vue&type=script&lang=ts&"
export * from "./TopTitleSubtitlePage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports